export function trackFbEvent(eventName: string, params?: Record<string, any>) {
  const w = window as any
  if (typeof w.fbq === 'function') {
    w.fbq('track', eventName, params)
  }
}
